import { GqlFieldworkerPreferredTransportationMethod, GqlPlannerV2TransportationMethod } from "~/__generated__/graphql/types.ts";

export function mapPreferredToPlannerTransportationMethod(
    preferredTransportationMethod: GqlFieldworkerPreferredTransportationMethod,
): GqlPlannerV2TransportationMethod {
    if (preferredTransportationMethod === GqlFieldworkerPreferredTransportationMethod.Bike) {
        return GqlPlannerV2TransportationMethod.Bike;
    }

    return GqlPlannerV2TransportationMethod.Car;
}
